import { Icon } from '@acast/decibel';
import { BullhornSolidGlyph, ExclamationTriangleSolidGlyph } from '@acast/decibel-glyphs';
import T from 'prop-types';
import React from 'react';
import { formatTime } from 'shared/helpers/time';
import { markerPropType } from '../../../../customPropTypes';
import {
  DEFAULT_THUMBNAIL,
  MARKER_TYPES,
  validateMarker,
} from '../../../../shared/helpers/markers';

const MarkerThumbnail = ({ type, thumbnail }) => {
  if (type === MARKER_TYPES.AD) {
    return (
      <div className="marker-thumbnail marker-thumbnail--ad">
        <Icon glyph={BullhornSolidGlyph} size="1em" />
      </div>
    );
  }

  return (
    <img
      src={thumbnail || DEFAULT_THUMBNAIL}
      className="marker-thumbnail"
      width="40"
      height="40"
      alt=""
    />
  );
};

MarkerThumbnail.propTypes = {
  type: T.string.isRequired,
  thumbnail: T.string,
};

const MarkersListItem = ({ marker, selected, isValid, onSelectMarker }) => (
  <div
    className={`marker-row ${selected ? 'selected' : ''} ${isValid ? 'valid' : ''}`}
    data-test-id={`MarkerListItem MarkerListItem--${marker.id}`}
    onMouseDown={() => onSelectMarker(marker.id)}
  >
    <div className="marker-type" data-test-id="MarkerListItem__type">
      <MarkerThumbnail type={marker.type} thumbnail={marker.thumbnail.original} />
      {marker.type}
    </div>
    <div className="marker-start-time" data-test-id="MarkerListItem__time">
      {formatTime(marker.start)}
    </div>
    <div className="marker-description">{marker.description}</div>
    <div className="marker-is-invalid">
      <Icon glyph={ExclamationTriangleSolidGlyph} size="1em" />
    </div>
  </div>
);

MarkersListItem.propTypes = {
  selected: T.bool.isRequired,
  isValid: T.bool.isRequired,
  marker: markerPropType,
  onSelectMarker: T.func.isRequired,
};

const filterAdMarkers = (markers = []) => markers.filter(marker => marker.type === MARKER_TYPES.AD);

const filterNonAdMarkers = (markers = []) =>
  markers.filter(marker => marker.type !== MARKER_TYPES.AD && marker.type !== MARKER_TYPES.AUDIO);

const sortMarkers = (markers = []) => markers.sort((a, b) => a.start - b.start);

const filterAndSortMarkers = (markers = []) => {
  const markersWithData = markers.filter(marker => Boolean(marker));
  const adMarkers = sortMarkers(filterAdMarkers(markersWithData));
  const nonAdMarkers = sortMarkers(filterNonAdMarkers(markersWithData));

  return adMarkers.concat(nonAdMarkers);
};

const MarkersList = ({ markers, selectedMarkerId, episodeDuration, onSelectMarker }) => (
  <div className="markers-list">
    <div className="markers-table" data-test-id="MarkersList__table">
      <div className="headings-row">
        <div>Type</div>
        <div>Position</div>
        <div>Note</div>
        <div />
      </div>
      {filterAndSortMarkers(markers).map(marker => (
        <MarkersListItem
          key={marker.id}
          marker={marker}
          isValid={!validateMarker(marker, episodeDuration)}
          selected={selectedMarkerId === marker.id}
          onSelectMarker={onSelectMarker}
        />
      ))}
    </div>
  </div>
);

MarkersList.propTypes = {
  selectedMarkerId: T.string,
  episodeDuration: T.number,
  markers: T.arrayOf(markerPropType),
  onSelectMarker: T.func.isRequired,
};

export default MarkersList;
